import { getConnector } from '@/services/externalLayers'

export const restLayerActivity = {
  methods: {
    startLayerSession(layer, mapId) {
      const backendurl = this.$store.getters.backendurl
      return this.$http.post(`${backendurl}api/v1/layer-activity/start`, {
        layer_id: layer.id,
        layer_name: layer.name,
        map_id: mapId || ''
      })
        .then((response) => {
          if (response.data && response.data.id) {
            this.$set(layer, '_sessionId', response.data.id)
          }
        })
        .catch((error) => {
          console.log('layer-activity start:', error)
        })
    },
    startExternalLayerSession(layer, mapId) {
      const backendurl = this.$store.getters.backendurl
      const providerName = layer.provider && layer.provider.name
      const serviceType = getConnector(providerName)?.serviceType || 'WMS'
      return this.$http.post(`${backendurl}api/v1/layer-activity/start-external`, {
        service_type: serviceType,
        url: (layer.provider && layer.provider.url) || '',
        layer_name: (layer.provider && layer.provider.layerName) || layer.name || '',
        map_id: mapId || ''
      })
        .then((response) => {
          if (response.data && response.data.id) {
            this.$store.commit('setWmsSessionId', { layerId: layer.id, sessionId: response.data.id })
          }
        })
        .catch((error) => {
          console.log('layer-activity start-external:', error)
        })
    },
    endLayerSession(layer) {
      const storeSessionId = this.$store.state.wmsSessionIds && this.$store.state.wmsSessionIds[layer.id]
      const sessionId = layer._sessionId || storeSessionId
      if (!sessionId) return
      const backendurl = this.$store.getters.backendurl
      if (storeSessionId) {
        this.$store.commit('clearWmsSessionId', layer.id)
      } else {
        this.$set(layer, '_sessionId', null)
      }
      return this.$http.patch(`${backendurl}api/v1/layer-activity/${sessionId}/end`)
        .catch((error) => {
          console.log('layer-activity end:', error)
        })
    }
  }
}
